export default "__VITE_ASSET__DVt3wEZH__"